import React from "react";
import { selectSlot, selectMentees, appMentor } from "./actions";
import { useQueryWithStore, useQuery } from "react-admin";
import { useDispatch, useSelector } from "react-redux";
import Parse from "parse";
import { useCallback } from "react";
// import { useState } from "react";
import { useParams } from "react-router";

export const useMentorProfileData = (mid) => {
  const mentorData = useQueryWithStore({
    type: "getOne",
    resource: "User",
    payload: {
      id: mid,
    },
  });
  return mentorData;
};

export const useMentorAvailabilityData = (aid, duration) => {
  console.log("aid", aid);
  console.log("duration", duration);
  const { mentorId } = useParams();
  console.log("mentorId", mentorId);
  const availabilityData = useQueryWithStore({
    type: "getOne",
    resource: "Availability",
    payload: {
      id: aid,
    },
  });
  const appointmentData = useQuery({
    type: "getList",
    resource: "Appointment",
    payload: {
      filter: {},
      pagination: { page: 1, perPage: 1000 },
      sort: { field: "id", order: "DSC" },
    },
  });

  console.log("appointmentData", appointmentData);
  console.log("mentorId", mentorId);
  appointmentData.data = appointmentData.loaded
    ? appointmentData.data.filter((value) => value.mentor.id === mentorId)
    : [];

  console.log("appointmentData", appointmentData);
  return {
    availabilityData,
    appointmentData,
  };
};

export const useEmailForUser = () => {
  async function getEmail(email) {
    console.log(`searching for ${email}`);
    const User = Parse.User;
    let qry = new Parse.Query(User);
    qry.equalTo("role", "user");
    qry.equalTo("email_", email);
    qry.select("id");
    console.log(`query : ${JSON.stringify(qry, 0, 2)}`);

    const resp = await qry.find();
    return resp;
  }

  return { getEmail };
};

export const useIdforUser = (id) => {
  const usrData = useQueryWithStore({
    type: "getOne",
    resource: "User",
    payload: {
      role: "user",
      id: id,
    },
  });

  return usrData;
};

export const useSelectedSlot = () => {
  const dispatch = useDispatch();
  const selectedSlot = useCallback((slot) => dispatch(selectSlot(slot)), [
    dispatch,
  ]);
  return { selectedSlot };
};

export const useSelectedMentees = () => {
  const dispatch = useDispatch();
  const selectedMentees = useCallback(
    (mentees) => dispatch(selectMentees(mentees)),
    [dispatch]
  );
  return { selectedMentees };
};

export const useSelectedMentor = () => {
  const dispatch = useDispatch();
  const selectedMentor = useCallback((mentor) => dispatch(appMentor(mentor)), [
    dispatch,
  ]);
  return { selectedMentor };
};

export const useAppointmentData = () => {
  const appointment = useSelector((state) => state.appointment);
  return appointment;
};

// const useZoomMeetingAPI = (_a) => {
//   /*
//    * Creating the api request parameters
//    */
//   console.log(`appointment ${JSON.stringify(_a, 0, 2)}`);
//   const [meeting, setMeeting] = useState({
//     loading: false,
//     loaded: false,
//     data: null,
//     error: null,
//   });

//   async function getMeeting() {
//     setMeeting({ loading: true, loaded: false, data: null, error: null });
//     const response = await Parse.Cloud.run("getZoomMeeting", _a);

//     console.log("API response", JSON.stringify(response, 0, 2));

//     if (response) {
//       setMeeting({ loading: false, loaded: true, data: response, error: null });
//       return response;
//     } else {
//       setMeeting({
//         loading: false,
//         loaded: true,
//         data: null,
//         error: response.error,
//       });
//       return response.error;
//     }
//   }

//   return [meeting, getMeeting];
// };

export const useAppointmentCreator = () => {
  const [appointment, setAppointment] = React.useState({
    loading: true,
    loaded: false,
    data: null,
    error: null,
  });

  const _a = useAppointmentData();
  async function commitAppointment(totalBill) {
    const makePayment = await Parse.Cloud.run("makePayment", {
      opration: "MakePayment",
      totalBill: totalBill,
      userDetails: _a,
    });
    console.log("makePayment", makePayment);

    console.log("totalBill", totalBill);
    console.log("_a", _a);
    const Appointment = Parse.Object.extend("Appointment");
    const apmt = new Appointment();
    apmt.set("mentor", _a.mentor);
    apmt.set("mentorName", _a.mentor.name);
    apmt.set("mentees", _a.mentees);
    apmt.set("appointmentTime", _a.slot.appointmentTime);
    apmt.set("duration", _a.slot.duration);
    apmt.set("appointmentDate", _a.slot.appointmentDate);
    apmt.set("Status", "Payment Pending");
    apmt.set("transactionId", makePayment.TransactionId);

    await apmt.save().then(
      async (apmt) => {
        const AppointmentInvites = Parse.Object.extend("AppointmentInvities");
        const apmtId = apmt.id;
        const mentees = apmt.get("mentees");

        mentees.map((m) => {
          const invities = new AppointmentInvites();
          invities.set("userId", m.id);
          invities.set("type", m.type);
          invities.set("appointmentId", apmtId);

          invities.save().then(
            (resp) => {
              console.log("invites", resp);
              return resp;
            },
            (err) => {
              console.log("invites error", err);
              return err;
            }
          );
          return null;
        });
        setAppointment({
          loading: false,
          loaded: true,
          data: apmt,
          error: null,
        });
        // const NonCloudMail = await Parse.Cloud.run("NonCloudMail", {
        //   opration: "CreateAppointment",
        //   // zoomMeeting: zoomMeeting,
        //   totalBill: totalBill,
        //   userDetails: _a,
        // });
        // console.log("NonCloudMail", NonCloudMail);
      },
      (error) => {
        setAppointment({
          loading: false,
          loaded: true,
          data: null,
          error: error,
        });
      }
    );
    window.open(makePayment.Payment, "_self");
  }
  return [appointment, commitAppointment];
};

// export const usePaymentStatusAppointment = () => {
//   const Appointment = Parse.Object.extend("Appointment");

//   async function useMeetingStatus(PayStatus) {
//     const AppointmentPurpose = new Parse.Query(Appointment);
//     await AppointmentPurpose.equalTo("transactionId", PayStatus.transactionid);
//     let SetPayAppointment = await AppointmentPurpose.first();
//     SetPayAppointment = {
//       id: SetPayAppointment.id,
//       ...SetPayAppointment.attributes,
//     };
//     console.log("SetPayAppointment", SetPayAppointment);

//     const response = await Parse.Cloud.run("getZoomMeeting", {
//       topic: "123Mentor Appointment",
//       dateTime:
//         SetPayAppointment.appointmentDate.substr(0, 11) +
//         SetPayAppointment.appointmentTime +
//         ":00",
//       duration: SetPayAppointment.duration,
//     });
//     console.log("response", response);
//     if (PayStatus.status === "pass") {
//       const AppointmentSet = new Parse.Query(Appointment);
//       await AppointmentSet.equalTo("transactionId", PayStatus.transactionid);
//       let SetPay = await AppointmentSet.first();

//       SetPay.set("Status", "Payment Success");
//       SetPay.set("zoomMeeting", JSON.stringify(response));

//       await SetPay.save();
//       const NonCloudMail = await Parse.Cloud.run("NonCloudMail", {
//         operation: "CreateAppointmentWithPaySuccess",
//         SetPayAppointment: SetPayAppointment,
//       });
//       console.log("NonCloudMail", NonCloudMail);
//     } else if (PayStatus.status === "fail") {
//       const AppointmentSet = new Parse.Query(Appointment);
//       await AppointmentSet.equalTo("transactionId", PayStatus.transactionid);
//       let SetPay = await AppointmentSet.first();
//       SetPay.set("Status", "Payment Failed");
//       SetPay.save();
//       const NonCloudMail = await Parse.Cloud.run("NonCloudMail", {
//         operation: "CreateAppointmentWithPayFailed",
//         SetPayAppointment: SetPayAppointment,
//       });
//       console.log("NonCloudMail", NonCloudMail);
//     }
//   }
//   return {useMeetingStatus};
// };
